import { api } from '../../lib/api';

export const REQ_STATUSES = [
  { value: 'Draft', label: 'Draft', tone: 'neutral' },
  { value: 'PendingApproval', label: 'Pending approval', tone: 'warning' },
  { value: 'Approved', label: 'Approved', tone: 'success' },
  { value: 'Rejected', label: 'Rejected', tone: 'danger' },
  { value: 'Cancelled', label: 'Cancelled', tone: 'neutral' },
  { value: 'Ordered', label: 'Ordered', tone: 'brand' },
];

export const reqStatusMeta = (status) =>
  REQ_STATUSES.find((s) => s.value === status) || { value: status, label: status, tone: 'neutral' };

export const REQ_PRIORITIES = [
  { value: 'Low', label: 'Low', tone: 'neutral' },
  { value: 'Normal', label: 'Normal', tone: 'neutral' },
  { value: 'High', label: 'High', tone: 'warning' },
  { value: 'Urgent', label: 'Urgent', tone: 'danger' },
];

export const reqPriorityMeta = (p) =>
  REQ_PRIORITIES.find((x) => x.value === p) || { value: p, label: p, tone: 'neutral' };

function toQuery(params) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const requisitionsApi = {
  list: (params = {}) => api.get(`/requisitions${toQuery(params)}`),
  get: (id) => api.get(`/requisitions/${id}`),
  create: (payload) => api.post('/requisitions', payload),
  update: (id, payload) => api.putWithId(`/requisitions/${id}`, id, payload),
  remove: (id) => api.del(`/requisitions/${id}`),
  submit: (id) => api.post(`/requisitions/${id}/submit`, {}),
  cancel: (id) => api.post(`/requisitions/${id}/cancel`, {}),
  approve: (id, comment) => api.post(`/requisitions/${id}/approve`, { comment: comment || null }),
  reject: (id, reason) => api.post(`/requisitions/${id}/reject`, { reason }),
  listActivity: (id, params = {}) => api.get(`/requisitions/${id}/activity${toQuery(params)}`),
};
